const CATEGORY_RULES = [
  { label: "Officer-Involved Shootings", keywords: ["officer-involved shooting", "deputy-involved shooting", "police shooting"] },
  { label: "Road Rage Shootings", keywords: ["road rage shooting", "shot during road rage"] },
  { label: "Shootings", keywords: ["shooting", "shots fired", "gunfire"] },
  { label: "Homicide Investigations", keywords: ["homicide", "murder investigation", "found dead"] },
  { label: "Pedestrian Crashes", keywords: ["pedestrian struck", "pedestrian hit", "person hit by vehicle"] },
  { label: "Hit-and-Runs", keywords: ["hit-and-run", "hit and run"] },
  { label: "Motorcycle Crashes", keywords: ["motorcycle crash", "motorcycle wreck"] },
  { label: "18-Wheeler Crashes", keywords: ["18-wheeler", "semi-truck crash", "truck wreck"] },
  { label: "Deadly Car Crashes", keywords: ["fatal crash", "fatal car crash", "deadly crash", "deadly wreck", "killed in crash"] },
  { label: "Car Crashes", keywords: ["crash", "wreck", "rollover", "accident"] },
  { label: "Police Chases", keywords: ["chase", "pursuit"] },
  { label: "SWAT & Standoffs", keywords: ["swat", "standoff", "barricaded"] },
  { label: "Armed Robberies", keywords: ["armed robbery", "held at gunpoint", "carjacking"] },
  { label: "Robberies", keywords: ["robbery", "robbed", "hold up", "held up", "burglary"] },
  { label: "Stabbings", keywords: ["stabbing", "stabbed"] },
  { label: "House Fires", keywords: ["house fire", "apartment fire", "garage fire"] },
  { label: "Fires", keywords: ["fire", "blaze", "smoke"] },
  { label: "Explosions", keywords: ["explosion", "exploded", "blast"] },
  { label: "Hazmat Incidents", keywords: ["hazmat", "chemical spill", "gas leak"] },
  { label: "Flooding", keywords: ["flood", "flash flood", "high water"] },
  { label: "Storm Damage", keywords: ["storm damage", "downed trees", "wind damage"] },
  { label: "Weather Alerts", keywords: ["storm", "tornado", "rain", "hail"] },
  { label: "Police Activity", keywords: ["police", "deputy", "sheriff"] },
  { label: "School Threats", keywords: ["school threat", "campus lockdown", "school lockdown"] },
  { label: "Missing & Endangered Persons", keywords: ["missing", "amber alert", "silver alert", "endangered missing"] },
  { label: "Deaths & Fatalities", keywords: ["dead", "death", "dies", "died", "fatality"] },
  { label: "Slumlords & Housing", keywords: ["slumlord", "apartment conditions", "mold", "unsafe housing"] },
  { label: "Corrupt Businesses", keywords: ["corrupt business", "scam", "fraud", "ripoff"] },
];

const AREA_RULES = [
  "Houston",
  "Galveston",
  "Dallas",
  "San Antonio",
  "Austin",
  "Katy",
  "The Woodlands",
  "Beaumont",
  "Cypress",
  "Pasadena",
  "Spring",
  "Pearland",
  "Baytown",
  "Sugar Land",
  "Humble",
  "Tomball",
  "Conroe",
  "League City",
  "Missouri City",
  "Rosenberg",
  "Kingwood",
  "Channelview",
];

const getHaystack = (story) => `${story?.headline || ""} ${story?.excerpt || ""} ${story?.caption || ""} ${story?.location || ""} ${story?.ai_story || ""} ${(story?.tags || []).join(" ")}`.toLowerCase();

export const getStoryCategoryData = (story) => {
  const section = story?.section;
  const haystack = getHaystack(story);
  const coverageArea = AREA_RULES.find((area) => haystack.includes(area.toLowerCase())) || "Houston";

  if (section === "sports") {
    return {
      sceneCategory: "Sports Headlines",
      coverageArea,
    };
  }

  if (section === "editorial") {
    return {
      sceneCategory: "What’s New",
      coverageArea,
    };
  }

  const matchedCategory = CATEGORY_RULES.find((rule) => rule.keywords.some((keyword) => haystack.includes(keyword)));

  if (matchedCategory?.label === "Deadly Car Crashes" && coverageArea === "Houston") {
    return {
      sceneCategory: "Deadly Car Crashes in Houston",
      coverageArea,
    };
  }

  return {
    sceneCategory: matchedCategory?.label || "General Incidents",
    coverageArea,
  };
};